import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { AllowBannedIpDialogData, AllowBannedIpDialogResult } from '../models/allow-banned-ip.model';

@Component({
   selector: 'ndt-allow-banned-ip-dialog',
   templateUrl: './allow-banned-ip-dialog.component.html',
   standalone: false,
})
export class AllowBannedIpDialogComponent implements FormComponent {
   form: UntypedFormGroup;

   constructor(
      private dialogRef: MatDialogRef<AllowBannedIpDialogComponent, AllowBannedIpDialogResult>,
      private dialogService: LcsDialogService,
      @Inject(MAT_DIALOG_DATA) public data: AllowBannedIpDialogData,
      fb: UntypedFormBuilder
   ) {
      this.form = fb.group({
         account: fb.control(null, Validators.required),
         ipAddress: fb.control({ disabled: true, value: data.ipAddress }),
         qManageTicketId: fb.control(null, [Validators.required, Validators.maxLength(20)]),
      });
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onAllow(): void {
      if (this.form.invalid) {
         this.form.markAllAsTouched();
         return;
      }

      this.form.markAsPristine();
      this.dialogRef.close({
         accountId: this.form.value.account.accountId,
         ipAddress: this.data.ipAddress,
         qManageTicketId: this.form.value.qManageTicketId.trim(),
      });
   }
}
